import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import client from './apollo/client';
import HomePage from './pages/HomePage';
import SupportPage from './pages/SupportPage';
import PolicyPage from './pages/Policy';
import './App.css';


function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/policy" element={<PolicyPage />} />
        </Routes>
      </Router>
    </ApolloProvider>
  );
}

export default App;
